import {Component, ElementRef, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {VueModeEnum} from './enums/VueModeEnum';
import {EnergieEnum} from './enums/EnergieEnum';
import {getGrapheTypeEnumName, GrapheTypeEnum} from './enums/GrapheTypeEnum';
import {NgbDate, NgbInputDatepicker, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {faAngleDown} from '@fortawesome/free-solid-svg-icons';
import {EnergieService} from '../../../services/rt2012/energie.service';
import {ConsommationsService} from '../../../services/rt2012/consommations.service';
import {Subscription} from 'rxjs';
import {LogementService} from '../../../services/logement.service';
import {Logement} from '../../../models/logement';
import {rubberBandOnEnterAnimation} from '../../../animations';
import {ReleveIndividuel} from '../../../models/rt2012/ReleveIndividuel';
import {Consommation} from '../../../models/rt2012/consommation';
import {NgbDateToIsoPipe} from '../../../pipes/ngbdate-to-iso.pipe';
import {SynthesePostesConsommation} from '../../../models/rt2012/synthesePostesConsommation';
import {SynthesePostesConsommationService} from '../../../services/rt2012/synthese-postes-consommation.service';
import {faCog, faPlus} from '@fortawesome/free-solid-svg-icons';
import {faCalendar} from '@fortawesome/free-regular-svg-icons';
import {UsageOccupant} from '../parametrage-usages/models/UsageOccupant';
import {environment} from '../../../../environments/environment';
import {UserService} from '../../../services/user.service';
import {User} from '../../../models/user';
import {ActivatedRoute} from '@angular/router';
import {UsagePoint} from '../../../models/rt2012/Enedis/UsagePoint';
import {UsagePoint as GazparUsagePoint} from '../../../models/rt2012/Gazpar/UsagePoint';
import {UsagePointSelectorService} from '../../../services/rt2012/usage-point-selector.service';
import {ErrorService} from '../../../services/error.service';
import { addDays, differenceInMonths, differenceInYears, startOfMonth, subMonths, subYears } from 'date-fns';
import {ConsommationEnergieByMonth} from "../../../services/rt2012/distribution/consommation-energie-by.month";
import {ConsommationEnergieByYear} from "../../../services/rt2012/distribution/consommation-energie-by.year";
import {ConsommationEnergieByDay} from "../../../services/rt2012/distribution/consommation-energie-by.day";
import {ActiveConsumptionPeriod} from "../../../models/rt2012/activeConsumptionPeriod";
import {TypeProductionEnum} from "../../../models/rt2012/typeProductionEnum";
import {TypeChauffageEnum} from "../../../models/rt2012/typeChauffageEnum";

@Component({
    selector: 'app-suivi-des-consommations',
    templateUrl: './suivi-des-consommations.component.html',
    styleUrls: ['./suivi-des-consommations.component.scss'],
    animations: [
        rubberBandOnEnterAnimation()
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SuiviDesConsommationsComponent implements OnInit, OnDestroy {
  VueModeEnum = VueModeEnum;
  EnergieEnum = EnergieEnum;
  faAngleDown = faAngleDown;
  faCalendar = faCalendar;
  faPlus = faPlus;
  faCog = faCog;
  SynthesePostesConsommation = SynthesePostesConsommation;

  selectedVueMode: VueModeEnum;
  selectedEnergie: EnergieEnum = EnergieEnum.ELECTRICITE;

  usagePoints: UsagePoint[];
  gazparUsagePoints: GazparUsagePoint[];

  @ViewChild('modalUsagePointId') modalUsagePointId: ElementRef;
  @ViewChild('datepicker') datePicker: NgbInputDatepicker;

  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  maxDate: NgbDate | null = null;
  hoveredDate: NgbDate | null = null;

  displayedConsommations: any = null;
  displayedSynthesePostesDeConsommations: any = null;
  customColors: any;
  barTooltipDisabled: boolean;
  activeBarLegend: { name: string, value: number, label: string, series: string } = null;
  @ViewChild('mobileValues') mobileValues: ElementRef;

  logement: Logement;
  user: User;

  energiesAvailables: EnergieEnum[] = [];
  energiesEditables: EnergieEnum[] = [];
  hasEnedisAccessToken: boolean;
  hasGazparAccessToken: boolean;
  loadingTerminate: boolean;

  coolingActiveConsumptionPeriods: ActiveConsumptionPeriod[] = null;
  heatingActiveConsumptionPeriods: ActiveConsumptionPeriod[] = null;
  relevesIndividuels: ReleveIndividuel[] = null;
  consommations: Consommation[] = [];
  synthesesPosteDeConsommation: SynthesePostesConsommation[] = [];

  private consommationsSubscription: Subscription = null;
  private logementSubscription: Subscription = null;
  private relevesIndividuelsSubscription: Subscription = null;
  private errorsSubscription: Subscription = null;

  GrapheTypeEnum = GrapheTypeEnum;
  grapheType: string;

  showNavBar = true;
  private readonly BREAKPOINT = 992;

  errorMessages: string[] = [];

  constructor(
    private energieService: EnergieService,
    private consommationsService: ConsommationsService,
    private synthesePostesConsommationService: SynthesePostesConsommationService,
    private logementService: LogementService,
    private ngbDateToIsoPipe: NgbDateToIsoPipe,
    public userService: UserService,
    private route: ActivatedRoute,
    public modalService: NgbModal,
    private usagePointSelectorService: UsagePointSelectorService,
    private errorService: ErrorService,
    @Inject(LOCALE_ID) private locale: string
  ) {
  }

  ngOnInit() {
    this.onResize();
    this.selectedVueMode = VueModeEnum.PAR_POSTE;
    this.grapheType = GrapheTypeEnum.MOIS;

    this.barTooltipDisabled = this.isTouchDevice();

    this.initPeriode();

    this.customColors = this.getCustomColors();

    this.errorsSubscription = this.synthesePostesConsommationService.errors?.subscribe(error => {
      this.errorMessages = error;
      this.errorService.toastErrors(error);
    });

    this.logementSubscription = this.logementService.logementCourant.subscribe(l => {
      this.logement = l;
      this.heatingActiveConsumptionPeriods = l.heatingActiveConsumptionPeriods;
      this.coolingActiveConsumptionPeriods = l.coolingActiveConsumptionPeriods;
      this.selectedVueMode = this.logement.canRT2012Repartition() ? VueModeEnum.PAR_POSTE : VueModeEnum.PAR_ENERGIE;
      this.reloadRelevesEtConsos();
      this.energiesAvailables = this.energieService.getEnergiesAvailables(this.logement);
      this.energiesEditables = this.energieService.getEnergiesEditables(this.logement);

      this.route.queryParams.subscribe(params => {
        if (params.usage_point_id) {
          this.usagePointSelectorService.loadUsagePoints(params.usage_point_id, String(this.logement.id)).then(usagePoints => {
            if (usagePoints.length > 0) {
              this.usagePoints = usagePoints;
              this.modalService.open(this.modalUsagePointId, {size: 'lg', windowClass: 'full-page'});
            }
          });
        }

        if (params.usage_point_gazpar_id) {
          this.usagePointSelectorService.loadUsagePointsGazpar(params.usage_point_gazpar_id, String(this.logement.id)).then(usagePoints => {
            if (usagePoints.length > 0) {
              this.gazparUsagePoints = usagePoints;
              this.modalService.open(this.modalUsagePointId, {size: 'lg', windowClass: 'full-page'});
            }
          });
        }
      });
    });
  }

  // NgbDate porte un mois 1-12, Date un mois 0-11 : ces deux helpers isolent
  // la conversion, qui était auparavant faite à la main à chaque appel.
  private static toNgbDate(date: Date): NgbDate {
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }

  private static fromNgbDate(date: NgbDate): Date {
    return new Date(date.year, date.month - 1, date.day);
  }

  initPeriode(): void {
    const toDate = new Date();
    const fromDate = startOfMonth(subMonths(toDate, 11));

    this.fromDate = SuiviDesConsommationsComponent.toNgbDate(fromDate);
    this.toDate = SuiviDesConsommationsComponent.toNgbDate(toDate);
    this.maxDate = SuiviDesConsommationsComponent.toNgbDate(toDate);
  }

  ngOnDestroy() {
    if (this.consommationsSubscription !== null) {
      this.consommationsSubscription.unsubscribe();
    }
    if (this.logementSubscription !== null) {
      this.logementSubscription.unsubscribe();
    }
    if (this.errorsSubscription !== null) {
      this.errorsSubscription.unsubscribe();
    }
  }

  public checkEnedisAccessToken(user: any, logement: any) {
    return user && user.enedisAccessTokens.filter(enedisAccessToken => enedisAccessToken.logement.id === logement.id).length > 0;
  }

  public checkGazparAccessToken(user: any, logement: any) {
    return user && user.gazparAccessTokens.filter(gazparAccessToken => gazparAccessToken.logement.id === logement.id).length > 0;
  }

  switchVueMode(vueMode: VueModeEnum) {
    this.selectedVueMode = vueMode;
    this.activeBarLegend = null;
    this.customColors = this.getCustomColors();
    switch (this.selectedVueMode) {
      case VueModeEnum.PAR_POSTE:
        this.updateDisplayedSynthesePostesDeConsommations();
        break;
      case VueModeEnum.PAR_ENERGIE:
        this.updateDisplayedConsommations();
        break;
    }
  }

  switchGrapheType(grapheType: GrapheTypeEnum) {
    this.grapheType = grapheType;
    this.refreshPeriod(grapheType);
    this.reloadRelevesEtConsos();
  }

  refreshPeriod(grapheType: GrapheTypeEnum) {
    const from = SuiviDesConsommationsComponent.fromNgbDate(this.fromDate);
    const to = SuiviDesConsommationsComponent.fromNgbDate(this.toDate);

    if (grapheType === GrapheTypeEnum.MOIS) {
      if (differenceInYears(to, from) > 1) {
        this.fromDate = SuiviDesConsommationsComponent.toNgbDate(startOfMonth(subYears(to, 2)));
      }
    }

    if (grapheType === GrapheTypeEnum.JOUR) {
      if (differenceInMonths(to, from) > 0) {
        this.fromDate = SuiviDesConsommationsComponent.toNgbDate(addDays(subMonths(to, 1), 1));
      }
    }
  }

  onDateSelection(date: NgbDate) {
    if (null !== this.fromDate && null !== this.toDate) {
      this.reloadRelevesEtConsos();
    }
  }

  isHovered(date: NgbDate): boolean {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate): boolean {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate): boolean {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  async reloadRelevesEtConsos() {
    await this.reloadReleves();
    await this.reloadSynthesesPostesDeConsommation();
    await this.reloadConsommations();
    await this.reloadUser();
    this.loadingTerminate = true;
  }

  reloadSynthesesPostesDeConsommation() {
    return new Promise<void>(resolve => {
      const from = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
      const to = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);

      this.consommationsSubscription = this.synthesePostesConsommationService.getAll(this.logement.id, from, to, this.grapheType)
        .subscribe(syntheses => {
          this.synthesesPosteDeConsommation = syntheses;
          this.updateDisplayedSynthesePostesDeConsommations();
          resolve();
        });
    });
  }

  reloadConsommations() {
    return new Promise<void>(resolve => {
      const from = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
      const to = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);

      this.consommationsSubscription = this.consommationsService.getAll(this.logement.id, from, to, this.grapheType).subscribe(consos => {
        this.consommations = consos;
        this.updateDisplayedConsommations();
        resolve();
      });
    });
  }

  reloadReleves(): Promise<void> {
    return new Promise(resolve => {
      const from = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
      const to = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
      this.relevesIndividuelsSubscription = this.consommationsService.getReleveIndividuels(this.logement.id, from, to)
        .subscribe(relevesIndividuels => {
          this.relevesIndividuels = relevesIndividuels;
          resolve();
        });
    });
  }

  reloadUser() {
    return new Promise<void>(resolve => {
      this.userService.load().then(data => {
        this.user = data;
        this.hasEnedisAccessToken = this.checkEnedisAccessToken(this.user, this.logement);
        this.hasGazparAccessToken = this.checkGazparAccessToken(this.user, this.logement);
        resolve();
      });
    });
  }

  private getCustomColors(): any {
    if (this.selectedVueMode === VueModeEnum.PAR_POSTE) {
      return [
        {name: 'Chauffage', value: SynthesePostesConsommation.CONSOMMATION_CHAUFFAGE_COLOR},
        {name: 'ECS', value: SynthesePostesConsommation.CONSOMMATION_ECS_COLOR},
        {name: 'Refroidissement', value: SynthesePostesConsommation.CONSOMMATION_REFROIDISSEMENT_COLOR},
        {name: 'Prises électriques', value: SynthesePostesConsommation.CONSOMMATION_PRISES_ELEC_COLOR},
        {name: 'Autres', value: SynthesePostesConsommation.CONSOMMATION_AUTRES_COLOR},
      ];
    } else {
      return this.energieService.getEnergies().map(e => ({
        name: e.type.toString(),
        value: e.color
      }));
    }
  }

  updateDisplayedConsommations() {
    const hasSelectedEnergie = !!this.consommations
      .filter(c => c.energie === this.selectedEnergie).length;

    if (!hasSelectedEnergie && this.consommations.length) {
      this.selectedEnergie = this.consommations[0].energie;
    }

    switch (this.grapheType) {
      case GrapheTypeEnum.ANNEE:
        this.displayedConsommations = new ConsommationEnergieByYear(this.locale, this.consommations, this.fromDate, this.toDate)
          .distribute(this.selectedEnergie);
        break;
      case GrapheTypeEnum.MOIS:
        this.displayedConsommations = new ConsommationEnergieByMonth(this.locale, this.consommations, this.fromDate, this.toDate)
          .distribute(this.selectedEnergie);
        break;
      case GrapheTypeEnum.JOUR:
        this.displayedConsommations = new ConsommationEnergieByDay(this.locale, this.consommations, this.fromDate, this.toDate)
          .distribute(this.selectedEnergie);
        break;
    }
  }

  updateDisplayedSynthesePostesDeConsommations() {
    const consoByMonth = {};

    for (const synthese of this.synthesesPosteDeConsommation) {
      const key = synthese.to.getTime();
      if (typeof consoByMonth[key] === 'undefined') {
        consoByMonth[key] = [];
      }
      consoByMonth[key].push({name: 'Chauffage', value: synthese.consommationChauffage});
      consoByMonth[key].push({name: 'ECS', value: synthese.consommationEcs});
      consoByMonth[key].push({name: 'Refroidissement', value: synthese.consommationRefroidissement});
      consoByMonth[key].push({name: 'Prises électriques', value: synthese.consommationPrisesElectrique});
      consoByMonth[key].push({name: 'Autres', value: synthese.consommationAutres});
    }
    this.displayedSynthesePostesDeConsommations = Object.keys(consoByMonth)
      .sort((a, b) => {
        return parseInt(a, 0) > parseInt(b, 0) ? 1 : -1;
      }).map(key => {
        const toDate = new Date(parseInt(key, 0));

        return {
          name: getGrapheTypeEnumName(this.locale, this.grapheType, toDate),
          series: [].concat(consoByMonth[key])
        };
      });
  }

  updateSelectedEnergie(newValue) {
    this.selectedEnergie = newValue;
    this.updateDisplayedConsommations();
  }

  onReleveAdded(releve: ReleveIndividuel) {
    this.modalService.dismissAll();
    this.reloadRelevesEtConsos();
  }

  onUsageOccupantUpdated(usageOccupant: UsageOccupant) {
    this.modalService.dismissAll();
    this.reloadRelevesEtConsos();
  }

  onPeriodAdded() {
    this.modalService.dismissAll();
    this.logementService.reloadLogementCourant().then(l => {
      this.heatingActiveConsumptionPeriods = l.heatingActiveConsumptionPeriods;
      this.coolingActiveConsumptionPeriods = l.coolingActiveConsumptionPeriods;
    });
  }

  getPosteDeConsoValeurForSerie(serie: string, poste: string) {
    let value = this.displayedSynthesePostesDeConsommations.find(s => {
      return s.name === serie;
    })?.series.find(p => {
      return p.name === poste;
    })?.value;

    if (!value) {
      value = 0;
    }

    value = parseInt(value, 0);

    return value;
  }

  isTouchDevice() {
    return 'ontouchstart' in window;
  }

  onClickOnBar($event: { name: string, value: number, label: string, series: string }) {
    if (this.isTouchDevice()) {
      this.activeBarLegend = $event;
      setTimeout(() => {
        this.mobileValues.nativeElement.scrollIntoView(false);
        window.scroll(0, window.scrollY + 10);
      });
    }
  }

  getFromLinky() {
    window.location.href = environment.rt2012.enedis.enedisConsentUrl + '?logement_id=' + this.logement.id;
  }

  public getFromGazpar() {
    window.location.href = environment.rt2012.grdf.grdfConsentUrl + '?logement_id=' + this.logement.id;
  }

  usagePointSelected(usagePoint: UsagePoint) {
    this.modalService.dismissAll();
    this.reloadRelevesEtConsos();
  }

  deleteEnedisToken() {
    window.location.href = environment.baseUrlBack + environment.rt2012.enedis.deleteAccessToken + '?logement_id=' + this.logement.id;
  }

  deleteGazparToken() {
    window.location.href = environment.baseUrlBack + environment.rt2012.grdf.deleteGrdfToken + '?logement_id=' + this.logement.id;
  }

  onResize() {
    this.showNavBar = (document.body.clientWidth > this.BREAKPOINT);
  }

  displayHeatingActivityPeriods(): boolean {
    return (this.hasGazparAccessToken
        && this.logement.parametrageBatiment?.typeProductionChauffage === TypeProductionEnum.INDIVIDUEL
        && (
          TypeChauffageEnum.CHAUDIERE_GAZ === this.logement.parametrageBatiment?.typeChauffage
          || TypeChauffageEnum.POMPE_CHALEUR_GAZ === this.logement.parametrageBatiment.typeChauffage
        ))
      || (
        this.hasEnedisAccessToken
        && this.logement.parametrageBatiment?.typeProductionRefroidissement === TypeProductionEnum.INDIVIDUEL
        && (
          TypeChauffageEnum.CONVECTEURS === this.logement.parametrageBatiment?.typeChauffage
          || TypeChauffageEnum.POMPE_CHALEUR_ELEC === this.logement.parametrageBatiment?.typeChauffage
        ));
  }

  displayCoolingActivityPeriods(): boolean {
    return this.hasEnedisAccessToken
    && this.logement.parametrageBatiment?.typeProductionRefroidissement === TypeProductionEnum.INDIVIDUEL;
  }
}
